import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { User } from '@interfaces/users.interface';

import { RootState } from '../store';

interface AuthState {
  user: User | null;
  isLoading: boolean;
}

const slice = createSlice({
  name: 'auth',
  initialState: { user: null, isLoading: true } as AuthState,
  reducers: {
    setCredentials: (state, { payload }: PayloadAction<User>) => {
      state.user = payload;
      state.isLoading = false;
    },
    stopLoadingAuth: (state) => {
      state.isLoading = false;
    },
    logout: (state) => {
      state.user = null;
      state.isLoading = false;
    },
  },
});

export const { setCredentials, stopLoadingAuth, logout } = slice.actions;
export const selectCurrentUser = (state: RootState) => state.auth.user;
export const selectIsLoadingAuth = (state: RootState) => state.auth.isLoading;

export default slice.reducer;
